import { useAtom } from "jotai";
import { useDebouncedCallback } from "use-debounce";

import { Tabs, TabsList, TabsTrigger } from "src/components/ui/tabs";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "src/components/ui/tooltip";

export function MetricsTabSwitcherFilter({
  tooltip,
  options,
  field,
  atom,
  disabled,
  defaultValue,
  queryVariableMapping = (v) => v,
  onSubmit,
}) {
  const [store, setStore] = useAtom(atom);
  const submitDebounce = useDebouncedCallback(() => {
    onSubmit?.();
  }, 200);

  const setValuesInStore = (newValues) => {
    setStore({
      ...store,
      [field]: newValues,
      ...(queryVariableMapping && {
        queryVariables: {
          ...store.queryVariables,
          [field]: queryVariableMapping(newValues),
        },
      }),
    });
  };

  return (
    <Tooltip delayDuration={1000} side="top">
      <TooltipTrigger asChild>
        <Tabs
          defaultValue={defaultValue || options[0].value}
          value={store[field] || defaultValue || options[0].value}
          onValueChange={(value) => {
            if (disabled || value === store[field]) {
              return;
            }

            setValuesInStore(value);
            submitDebounce();
          }}
        >
          <TabsList className="dark:bg-input/30 border-input h-8 rounded-md border">
            {options.map((option) => (
              <TabsTrigger
                key={option.value}
                value={option.value}
                className="h-6 gap-1"
                disabled={disabled}
              >
                {option.title}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      </TooltipTrigger>
      {tooltip && <TooltipContent>{tooltip}</TooltipContent>}
    </Tooltip>
  );
}
